import { useContext } from "react";
import { useMutation } from "react-query";
import { ApiContext } from "../../contexts/ApiContext";
import { ReportingPayload } from "../../shared/interfaces/ReportingPayload";
import { QueryCallbacks } from "../../shared/interfaces/ReactQuery";

export function useGenerateAppendix(callbacks?: QueryCallbacks<number>) {
  const apiContext = useContext(ApiContext);

  return useMutation(
    ["generateAppendix"],
    async (reportingPayload: ReportingPayload) => apiContext.utp2FilesAPIs.generateAppendix(reportingPayload),
    {
      onSuccess: callbacks?.onSuccess,
      onError: callbacks?.onError,
    },
  );
}
